import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/calculation");
  }, []);
  return (
    <>
      <h1>CONTACT</h1>
    </>
  );
};

export default Contact;
